import Vue from 'vue';
import Router from 'vue-router';

import store from '@/store';
import auth from '@/auth';

import SignIn from './views/Signin.vue';


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/offers',
    },
    {
      path: '/login',
      name: 'login',
      component: SignIn,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '/offers',
      name: 'offers',
      component: () => import(/* webpackChunkName: "offers" */ './views/Offers.vue'),
      meta: {
        requiresAuth: true,
        requiresAccess: true,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  auth.initiator().then(() => {
    next();
  });
});

router.beforeEach((to, from, next) => {
  const currentUser = store.state.auth;

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const requiresAccess = to.matched.some(record => record.meta.requiresAccess);

  if (requiresAuth && !currentUser.isSignedIn) {
    console.error('ROUTER: user is not logged in');
    return next('login');
  } else if (requiresAccess && !currentUser.hasAccess) {
    console.error('ROUTER: user has no access');
    return next('login');
  }

  return next();
});

export default router;
